import React, { useEffect, useState } from "react";
import GuideStyles from "assets/js/guide";
import {
  Box,
  Button,
  Drawer,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  Slide,
  AppBar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Toolbar,
  Typography,
} from "@mui/material";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function GuideDrawer(props) {
  const [drawerFull, setDrawerFull] = useState(false);
  const [drawerHigh, setDrawerHigh] = useState(false);
  const [drawerCenter, setDrawerCenter] = useState(false);
  const [drawerRow, setDrawerRow] = useState(false);
  const [trustDetail, setTrustDetail] = useState(false);
  const [alert, setAlert] = useState(false);
  const [dialogFull, setDialogFull] = useState(false);
  drawerHigh;

  const handleDrawerFullOpen = () => {
    setDrawerFull(true);
  };
  const handleDrawerFullClose = () => {
    setDrawerFull(false);
  };

  const handleDrawerHighOpen = () => {
    setDrawerHigh(true);
  };
  const handleDrawerHighClose = () => {
    setDrawerHigh(false);
  };

  const handleDrawerRowOpen = () => {
    setDrawerRow(true);
  };
  const handleDrawerRowClose = () => {
    setDrawerRow(false);
  };

  const handleTrustDetailOpen = () => {
    setTrustDetail(true);
  };
  const handleTrustDetailClose = () => {
    setTrustDetail(false);
  };

  const handleAlertOpen = () => {
    setAlert(true);
  };
  const handleAlertClose = () => {
    setAlert(false);
  };

  const handleDialogFullOpen = () => {
    setDialogFull(true);
  };
  const handleDialogFullClose = () => {
    setDialogFull(false);
  };

  const handleDrawerCenterOpen = () => {
    setDrawerCenter(true);
  };
  const handleDrawerCenterClose = () => {
    setDrawerCenter(false);
  };

  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = (panel) => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div class="h-group">
            <h2 className="guide-h2">Popup</h2>
          </div>

          <h3 className="guide-h3">Drawer Bottom - size : Full</h3>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleDrawerFullOpen}
          >
            Size - Full
          </Button>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleTrustDetailOpen}
          >
            TrustDetail
          </Button>

          <Accordion
            codemirror={codemirror === "DrawerFull"}
            onChange={handleCodemirror("DrawerFull")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`import {
  Drawer,
  Box,
  Button,
  IconButton,
} from "@mui/material";

<Drawer
  anchor="bottom"
  open={drawerFull}
  onClose={handleDrawerFullClose}
  className="drawer-common-bottom size-full"
>
  <div className="drawer-head">
    <h3>Title</h3>
    <IconButton
      aria-label="close"
      className="btn-close"
      onClick={handleDrawerFullClose}
    >
      <span className="hidden">닫기</span>
    </IconButton>
  </div>

  <div className="drawer-body">
    <Box className="box-type-1">Contents</Box>
  </div>
  <div className="drawer-foot">
    <Button color="primary" variant="contained">
      Button
    </Button>
  </div>
</Drawer>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Drawer Bottom - size : high</h3>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleDrawerHighOpen}
          >
            Size - High
          </Button>

          <Accordion
            codemirror={codemirror === "DrawerHigh"}
            onChange={handleCodemirror("DrawerHigh")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`import {
  Drawer,
  Box,
  Button,
  IconButton,
} from "@mui/material";

<Drawer
  anchor="bottom"
  open={drawerHigh}
  onClose={handleDrawerHighClose}
  className="drawer-common-bottom size-high"
>
  <div className="drawer-head">
    <h3>Title</h3>
    <IconButton
      aria-label="close"
      className="btn-close"
      onClick={handleDrawerHighClose}
    >
      <span className="hidden">닫기</span>
    </IconButton>
  </div>

  <div className="drawer-body">
    <Box className="box-type-1">Contents</Box>
  </div>
  <div className="drawer-foot">
    <Button color="primary" variant="contained">
      Button
    </Button>
  </div>
</Drawer>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Drawer Bottom - title : center</h3>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleDrawerCenterOpen}
          >
            Title - Center
          </Button>

          <Accordion
            codemirror={codemirror === "DrawerHigh"}
            onChange={handleCodemirror("DrawerHigh")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`import {
  Drawer,
  Box,
  Button,
  IconButton,
} from "@mui/material";

<Drawer
  anchor="bottom"
  open={drawerHigh}
  onClose={handleDrawerHighClose}
  className="drawer-common-bottom size-high title-center"
>
  <div className="drawer-head">
    <h3>Title</h3>
    <IconButton
      aria-label="close"
      className="btn-close"
      onClick={handleDrawerHighClose}
    >
      <span className="hidden">닫기</span>
    </IconButton>
  </div>

  <div className="drawer-body">
    <Box className="box-type-1">Contents</Box>
  </div>
  <div className="drawer-foot">
    <Button color="primary" variant="contained">
      Button
    </Button>
  </div>
</Drawer>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Drawer Bottom - size : row</h3>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleDrawerRowOpen}
          >
            Size - row
          </Button>

          <Accordion
            codemirror={codemirror === "DrawerRow"}
            onChange={handleCodemirror("DrawerRow")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`import {
  Drawer,
  Box,
  Button,
  IconButton,
} from "@mui/material";

<Drawer
  anchor="bottom"
  open={drawerRow}
  onClose={handleDrawerRowClose}
  className="drawer-common-bottom size-small"
>
  <div className="drawer-body">
    <div className="box-type-1 align-c">
      <div className="illust">
        <img
          src={${process.env.PUBLIC_URL}/images/img/illust-check.svg}
        />
      </div>
      <p className="text">
        <strong>간편 비밀번호가 변경되었습니다</strong>
      </p>
      <Box component="span" className="count" mt={3}>
        03
      </Box>
    </div>
  </div>
  <div className="drawer-foot">
    <Button color="primary" variant="contained">
      Button
    </Button>
  </div>
</Drawer>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Dialog Bottom - size : full</h3>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleDialogFullOpen}
          >
            Size - full
          </Button>

          <Accordion
            codemirror={codemirror === "DialogFull"}
            onChange={handleCodemirror("DialogFull")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Box,
  Button,
  IconButton,
  AppBar,
  Typography
} from "@mui/material";

<Dialog
  fullScreen
  open={dialogFull}
  onClose={handleDialogFullClose}
  TransitionComponent={Transition}
  className="policy-wrap"
>
  <AppBar>
    <Toolbar>
      <h2 className="h2">이용약관</h2>
      <IconButton
        aria-label="close"
        className="btn-close"
        onClick={handleDialogFullClose}
      >
        <span className="hidden">닫기</span>
      </IconButton>
    </Toolbar>
  </AppBar>
  <DialogContent>
    <Box className="box-type-1">
      <Typography mb={6}>
        (주)메가마트(이하 “회사”라 한다)는 회원의 개인정보를 중요시하며
        정보통신망법, 개인정보보호법 등 “회사”가 준수 하여야 할 법령상의
        개인정보보호 규정을 준수하고 있습니다.
        <br />
        “회사”는 개인정보취급방침을 통하여 메가훼미리 포인트 카드
        회원(이하 “회원”이라 한다)이 제공하는 개인정보가 어떠한 용도와
        방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가
        취해지고 있는지 알려드립니다.
      </Typography>

      <h3>제1장. 총칙</h3>

      <h4>제1조(목적)</h4>
      <p>
        본 약관은 ㈜메가마트(이하 "회사"라 한다)가 제공하는 "메가포인트
        훼미리카드 서비스" 이용과 관련한 제반 사항을 명확히 규정함으로써
        "메가포인트 훼미리카드 회원" 에 대한 서비스 증진을 도모함을 그
        목적으로 합니다.
      </p>

      <h4>제2조(용어의 정의)</h4>
      <ul className="list list-num list-num-round font-14">
        <li>
          "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본
          약관에 동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을
          말합니다.
        </li>
        <li>
          "메가포인트 훼미리카드 서비스(이하 "서비스"라 한다)" 란 "회사"가
          제공하는 서비스로서 그 내용은 본 약관 제2장에 기술된 바와
          같습니다.
        </li>
        <li>
          "메가포인트 훼미리카드(이하 "카드"라 한다)”란 “회사" 가 인정하는
          절차 및 방법에 따라 발급되어 "서비스"를 정상적으로 사용할 수
          있도록 승인된 "카드"를 말합니다.
        </li>
        <li>
          "메가포인트 훼미리카드 포인트(이하 "포인트"라 한다)" 란 “회원"이
          상품을 구매하거나 서비스를 이용하는 경우 "회사"가 정하는 바에
          따라 부여되는 "포인트"를 의미합니다.
        </li>
      </ul>

      <Box mt={6}>
        <table className="tbl-row">
          <colgroup>
            <col style={{ width: "32%" }} />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">제공받는 자</th>
              <td>관할세무서</td>
            </tr>
            <tr>
              <th scope="row">이용목적</th>
              <td>주류 통신판매 주문에 대한 분기별 명세 세무서 제공</td>
            </tr>
            <tr>
              <th scope="row">제공하는 개인정보 항목</th>
              <td>
                주문자 인적사항(주소, 성명, 생년월일), 주문일자, 상품명,
                수량, 주문금액
              </td>
            </tr>
            <tr>
              <th scope="row">보유 및 이용기간</th>
              <td>국세청 고시에 다른 보존기간</td>
            </tr>
          </tbody>
        </table>
      </Box>

      <h4>제2조(용어의 정의)</h4>

      <h3>제2장. 총칙</h3>
    </Box>
  </DialogContent>
</Dialog>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Dialog Center - alert</h3>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleAlertOpen}
          >
            Alert
          </Button>

          <Accordion
            codemirror={codemirror === "DialogFull"}
            onChange={handleCodemirror("DialogFull")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Box,
  Button,
  IconButton,
  AppBar,
  Typography
} from "@mui/material";

<Dialog open={alert} onClose={handleAlertClose} className="alert-wrap">
  <DialogContent>
    <DialogContentText>등록되었습니다.</DialogContentText>
  </DialogContent>
  <DialogActions className="btn-center">
    {/* <Button onClick={handleAlertClose}>Disagree</Button> */}
    <Button
      onClick={handleAlertClose}
      autoFocus
      variant="contained"
      color="primary"
      size="small"
    >
      확인
    </Button>
  </DialogActions>
</Dialog>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      </main>

      {/* ST : Drawer-full */}
      <Drawer
        anchor="bottom"
        open={drawerFull}
        onClose={handleDrawerFullClose}
        className="drawer-common-bottom size-full"
      >
        <div className="drawer-head">
          <h3>Title</h3>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={handleDrawerFullClose}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Box className="box-type-1">Contents</Box>
        </div>
        <div className="drawer-foot">
          <Button color="primary" variant="contained">
            Button
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-full */}

      {/* ST : Drawer-trust-detail */}
      <Drawer
        anchor="bottom"
        open={trustDetail}
        onClose={handleTrustDetailClose}
        id="trustDetail"
        className="drawer-common-bottom size-full"
      >
        <div className="drawer-head">
          <h3>
            로맨틱한 오늘의 데이트, <br />
            집에서 즐기는 설렘 가득 홈bar 🥂
          </h3>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={handleTrustDetailClose}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <div className="img-area">img-area</div>
          <Box className="box-type-1">text</Box>
        </div>
        <div className="drawer-foot">
          <Button color="primary" variant="contained">
            Button
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-trust-detail */}

      {/* ST : Drawer-high */}
      <Drawer
        anchor="bottom"
        open={drawerHigh}
        onClose={handleDrawerHighClose}
        className="drawer-common-bottom size-high"
      >
        <div className="drawer-head">
          <h3>Title</h3>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={handleDrawerHighClose}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Box className="box-type-1">Contents</Box>
        </div>
        <div className="drawer-foot">
          <Button color="primary" variant="contained">
            Button
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-high */}

      {/* ST : Drawer-row */}
      <Drawer
        anchor="bottom"
        open={drawerRow}
        onClose={handleDrawerRowClose}
        className="drawer-common-bottom size-small"
      >
        <div className="drawer-body">
          <div className="box-type-1 align-c">
            <div className="illust">
              <img
                src={`${process.env.PUBLIC_URL}/images/img/illust-check.svg`}
              />
            </div>
            <p className="text">
              <strong>간편 비밀번호가 변경되었습니다</strong>
            </p>
            <Box component="span" className="count" mt={3}>
              03
            </Box>
          </div>
        </div>
        <div className="drawer-foot">
          <Button color="primary" variant="contained">
            Button
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-row */}

      {/* ST : Dialog - full */}
      <Dialog
        fullScreen
        open={dialogFull}
        onClose={handleDialogFullClose}
        TransitionComponent={Transition}
        className="policy-wrap"
      >
        <AppBar>
          <Toolbar>
            <h2 className="h2">이용약관</h2>
            <IconButton
              aria-label="close"
              className="btn-close"
              onClick={handleDialogFullClose}
            >
              <span className="hidden">닫기</span>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Box className="box-type-1">
            <Typography mb={6}>
              (주)메가마트(이하 “회사”라 한다)는 회원의 개인정보를 중요시하며
              정보통신망법, 개인정보보호법 등 “회사”가 준수 하여야 할 법령상의
              개인정보보호 규정을 준수하고 있습니다.
              <br />
              “회사”는 개인정보취급방침을 통하여 메가훼미리 포인트 카드
              회원(이하 “회원”이라 한다)이 제공하는 개인정보가 어떠한 용도와
              방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가
              취해지고 있는지 알려드립니다.
            </Typography>

            <h3>제1장. 총칙</h3>

            <h4>제1조(목적)</h4>
            <p>
              본 약관은 ㈜메가마트(이하 "회사"라 한다)가 제공하는 "메가포인트
              훼미리카드 서비스" 이용과 관련한 제반 사항을 명확히 규정함으로써
              "메가포인트 훼미리카드 회원" 에 대한 서비스 증진을 도모함을 그
              목적으로 합니다.
            </p>

            <h4>제2조(용어의 정의)</h4>
            <ul className="list list-num list-num-round font-14">
              <li>
                "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본
                약관에 동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을
                말합니다.
              </li>
              <li>
                "메가포인트 훼미리카드 서비스(이하 "서비스"라 한다)" 란 "회사"가
                제공하는 서비스로서 그 내용은 본 약관 제2장에 기술된 바와
                같습니다.
              </li>
              <li>
                "메가포인트 훼미리카드(이하 "카드"라 한다)”란 “회사" 가 인정하는
                절차 및 방법에 따라 발급되어 "서비스"를 정상적으로 사용할 수
                있도록 승인된 "카드"를 말합니다.
              </li>
              <li>
                "메가포인트 훼미리카드 포인트(이하 "포인트"라 한다)" 란 “회원"이
                상품을 구매하거나 서비스를 이용하는 경우 "회사"가 정하는 바에
                따라 부여되는 "포인트"를 의미합니다.
              </li>
            </ul>

            <Box mt={6}>
              <table className="tbl-row">
                <colgroup>
                  <col style={{ width: "32%" }} />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">제공받는 자</th>
                    <td>관할세무서</td>
                  </tr>
                  <tr>
                    <th scope="row">이용목적</th>
                    <td>주류 통신판매 주문에 대한 분기별 명세 세무서 제공</td>
                  </tr>
                  <tr>
                    <th scope="row">제공하는 개인정보 항목</th>
                    <td>
                      주문자 인적사항(주소, 성명, 생년월일), 주문일자, 상품명,
                      수량, 주문금액
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">보유 및 이용기간</th>
                    <td>국세청 고시에 다른 보존기간</td>
                  </tr>
                </tbody>
              </table>
            </Box>

            <h4>제2조(용어의 정의)</h4>

            <h3>제2장. 총칙</h3>
          </Box>
        </DialogContent>
      </Dialog>
      {/* EN : Dialog - full */}

      {/* ST : Alert */}
      <Dialog open={alert} onClose={handleAlertClose} className="alert-wrap">
        <DialogTitle className="tit-center">알림</DialogTitle>
        <DialogContent>
          <DialogContentText>
            단골매장을 설정하시려면
            <br />
            로그인이 필요합니다.
            <br />
            로그인 화면으로 이동하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions className="btn-center">
          <Button
            onClick={handleAlertClose}
            variant="contained"
            className="btn-cancel"
          >
            취소
          </Button>
          <Button
            onClick={handleAlertClose}
            autoFocus
            variant="contained"
            color="primary"
            // size="small"
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
      {/* EN : Alert */}

      {/* ST : Drawer-title-center */}
      <Drawer
        anchor="bottom"
        open={drawerCenter}
        onClose={handleDrawerCenterClose}
        className="drawer-common-bottom size-high title-center"
      >
        <div className="drawer-head">
          <h3>Title</h3>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={handleDrawerCenterClose}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Box className="box-type-1">Contents</Box>
        </div>
        <div className="drawer-foot">
          <Button color="primary" variant="contained">
            Button
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-title-center */}
    </>
  );
}
